<template lang="html">
	<div class="ad-ratings clearfix">
		<div class="row row-flex">
			<div class="col-4 col-md-12 col-xl-4">
				<div class="image-box f-l">
					<img
						v-if="product.advert_image"
						:src="
							getImageUrl(product.advert_image.web) ||
							'/img/logos/madison.png'
						"
						alt=""
						class="logo"
					/>
					<img
						v-else
						:src="'/img/logos/madison.png'"
						alt=""
						class="logo"
					/>
				</div>
			</div>
			<div class="col-8 col-md-12 col-xl-8">
				<div class="p-desc-box f-l">
					<div class="p-name">{{ product.advert_category }}</div>
					<div class="insurance">
						{{ product.advert_description }}
					</div>

					<!-- <div class="price-box clearfix">
                  <div class="last f-l strikethrough">{{product.currency}}{{utils.numberWithCommas(product.last_price)}}</div>
                  <div class="price tx-blue f-l">{{product.currency}}{{utils.numberWithCommas(product.price)}}<span class="point">.00</span></div>
               </div> -->

					<div class="rate">
						<div class="stars">
							<!-- <vue-stars
                        active-color="#ffbf71"
                        inactive-color="#c0c4d1"
                        shadow-color="#ffbf71"
                        :max="5"
                        :value="product.rating"
                        :readonly="true"
                        inactive-char=""
                        :class=""
                     /> -->
						</div>
						<!-- <div class="reviews">
                     <div class="review-content" v-if="product.reviews > 0">{{Math.round(product.rating)}}.0 out of 5 ({{product.reviews}} Reviews)</div>
                     <div class="n-content" v-else>No Reviews</div>
                  </div> -->
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		product: {
			default: function () {
				return {
					advert_category: 'Ndae Freshi',
					advert_description: 'Sanlam Insurance',
					features: ['Theft Protection', 'Collision Damage Waiver'],
					currency: '$',
					price: 34000,
					last_price: 59000,
					rating: 4,
					reviews: 28,
					rating: 4,
					advert_image: {
						web: null,
					},
				};
			},
		},
	},
	data() {
		return {
			utils,
			api,
		};
	},
	methods: {
		getImageUrl(route) {
			if (route) {
				if (route.startsWith('/')) {
					return `${api.getDomain()}${route}`;
				} else {
					return `${api.getDomain()}/${route}`;
				}
			} else {
				return undefined;
			}
		},
	},
};
</script>

<style lang="less">
@grey: #a7abbd;

.ad-ratings {
	background: var(--white);
	box-shadow: 0 10px 23px 0 #45495b19;
	border-radius: 4px;

	.col-4 {
		padding: 0 !important;
	}
	.image-box {
		background: #eceef2;
		height: 100%;
		text-align: center;
		width: 100%;

		.logo {
			width: auto;
			height: auto;
			max-width: 80%;
			max-height: 70%;
			padding: 30% 0 0 0;
			position: relative;
		}
	}
	.p-desc-box {
		margin: 0 0 0 20px;
		padding: 20px 15px;

		.rate {
			margin: 15px 0 0 0 !important;

			.n-content {
				color: #e4e5ec;
				font-style: italic;
			}
			.review-content {
				color: #9196a8;
			}
			.stars {
				margin: 1px 10px 0 0;
				.active,
				.inactive {
					font-size: 18px;
				}
				label {
					font-size: 16px;
				}
			}
		}
		.p-name {
			font-size: 17px;
			color: var(--text-color);
			font-family: var(--font-bold);
			line-height: 15px;
		}
		.insurance {
			font-size: 13px;
			color: var(--text-grey);
		}
		.categories {
			margin: 5px 0;
			font-size: 14px;
			color: @grey;

			.name {
				font-weight: 600;
			}
			.icon {
				margin: 1px 10px 0 0;
			}
		}
		.price-box {
			margin: 8px 0;

			.price {
				font-size: 26px;
				font-family: var(--font-bold);

				.point {
					font-size: 11px;
				}
			}
			.last {
				margin: 1px 10px 0 0;
				font-weight: 600;
				color: @grey;
				font-size: 14px;
			}
		}
	}
}
</style>
